import { createSelector } from 'reselect'

export const getPhasesInfo = (state) => state.mars.phases

export const getCurrentPhase = createSelector([getPhasesInfo], (info) => info.phase)

export const getError = createSelector([getPhasesInfo], (info) => info.error)
